module.exports = __webpack_public_path__ + "static/media/unis-goals-2.cb5ede78.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/unis-goals-2.png
 ** module id = 522
 ** module chunks = 0
 **/